import styled from 'styled-components';

// Style
import { Mult } from '../../styles/forms';

/**
 * Formata o Container do Multiplicador
 *
 * @extends {Mult}
 */

export const ContainerMultiply = styled(Mult)`
  display: flex;
  flex-direction: row;
`;
